import { Component, Input } from '@angular/core';
import { helpCardModel } from '../help-card/help-card-model';

@Component({
    selector: 'app-help-card-slide',
    templateUrl: './help-card-slide.component.html',
    styleUrls: ['./help-card-slide.component.scss']
})
export class HelpCardSlideComponent {
    @Input() public helpCenterModel: Array<any> = helpCardModel;
    public notRedirect: boolean = false;

    public receiveEvent($event: any): void {
        this.notRedirect = $event;
    }
}
